import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getProps } from '../../../tutor-on-demand/blog/[slug]'

export const getStaticProps = getStaticPropsWrapper(getProps, { campaign: true })

export { default, getStaticPaths } from '../../../tutor-on-demand/blog/[slug]'
